import {FiChevronDown} from "react-icons/fi"
import {AiFillStar, AiOutlineStar} from "react-icons/ai"
import "../Styles/Component/ProductSidebar.css"
import { useState } from "react"

const ProductSidebar = ({handleChange}) => {
    const [category, setCategory] = useState(true)
    const [price, setPrice] = useState(true)
    const [rating, setRating] = useState(true)
    const [showFilter, setShowFilter] = useState(false)

    const showList = (group) => {
        if(group === "category"){
            setCategory(!category)
        }else if(group === "rating"){
            setRating(!rating)
        }else if(group === "price"){
            setPrice(!price)
        }
        console.log(category)
    }

    return <>
    <div className="filter">
        <button onClick={() => setShowFilter(!showFilter)}>Filter</button>
    </div>
        <section className={showFilter && window.innerWidth <= 1000 ? "sidebar" : window.innerWidth > 1000 ? "sidebar" : "hide"}>
        <p className="close" onClick={() => setShowFilter(false)}>x</p>
            <div className="sidebarWrapper">
                <div className="sidebar_groups">
                    <div className="sidebar_group_heading">
                        <h2>Category</h2>
                        <FiChevronDown  onClick={() => showList("category")}/>
                    </div>
                    <ul className={category ? "group" : "hide"}>
                        <li>
                            <input type="radio" name="category" id="" onChange={handleChange} value=""/>
                            All
                        </li>
                        <li>
                            <input type="radio" name="category" id="" onChange={handleChange} value={"Fruits"}/>
                            Fruits
                        </li>
                        <li>
                            <input type="radio" name="category" id="" onChange={handleChange} value="Vegetables"/>
                            Vegetables
                        </li>
                        <li>
                            <input type="radio" name="category" id="" onChange={handleChange} value="Grains"/>
                            Grains
                        </li>
                        <li>
                            <input type="radio" name="category" id="" onChange={handleChange} value="Legumes"/>
                            Legumes
                        </li>
                        <li>
                            <input type="radio" name="category" id="" onChange={handleChange} value="Meat"/>
                            Meat
                        </li>
                        <li>
                            <input type="radio" name="category" id="" onChange={handleChange} value="Seafood"/>
                            Seafood
                        </li>
                    </ul>
                </div>
                <div className="sidebar_groups">
                    <div className="sidebar_group_heading">
                        <h2>Price</h2>
                        <FiChevronDown onClick={() => showList("price")}/>
                    </div>
                    <ul className={price ? "group" : "hide"}>
                        <li>
                            <input type="radio" name="price" id="" onChange={handleChange} value=""/>
                            All
                        </li>
                        <li>
                            <input type="radio" name="price" id="" onChange={handleChange} value={50}/>
                            $0 - $50
                        </li>
                        <li>
                            <input type="radio" name="price" id="" onChange={handleChange} value={100}/>
                            $50 - $100
                        </li>
                        <li>
                            <input type="radio" name="price" id="" onChange={handleChange} value={150}/>
                            $100 - %150
                        </li>
                        <li>
                            <input type="radio" name="price" id="" onChange={handleChange} value={200}/>
                            Over $150
                        </li>
                    </ul>
                </div>
                <div className="sidebar_groups">
                    <div className="sidebar_group_heading">
                        <h2>Ratings</h2>
                        <FiChevronDown onClick={() => showList("rating")}/>
                    </div>
                    <ul  className={rating ? "group" : "hide"}>
                        <li>
                            <input type="radio" name="rating" id="" onChange={handleChange} value={5}/>
                            <div className="rating">
                                <AiFillStar/>
                                <AiFillStar/>
                                <AiFillStar/>
                                <AiFillStar/>
                                <AiFillStar/>
                            </div>
                        </li>
                        <li>
                            <input type="radio" name="rating" id="" onChange={handleChange} value={4}/>
                            <div className="rating">
                                <AiFillStar/>
                                <AiFillStar/>
                                <AiFillStar/>
                                <AiFillStar/>
                                <AiOutlineStar/>
                            </div>
                        </li>
                        <li>
                            <input type="radio" name="rating" id="" onChange={handleChange} value={3}/>
                            <div className="rating">
                                <AiFillStar/>
                                <AiFillStar/>
                                <AiFillStar/>
                                <AiOutlineStar/>
                                <AiOutlineStar/>
                            </div>
                        </li>
                        <li>
                            <input type="radio" name="rating" id="" onChange={handleChange} value={2}/>
                            <div className="rating">
                                <AiFillStar/>
                                <AiFillStar/>
                                <AiOutlineStar/>
                                <AiOutlineStar/>
                                <AiOutlineStar/>
                            </div>
                        </li>
                        <li>
                            <input type="radio" name="rating" id="" onChange={handleChange} value={1}/>
                            <div className="rating">
                                <AiFillStar/>
                                <AiOutlineStar/>
                                <AiOutlineStar/>
                                <AiOutlineStar/>
                                <AiOutlineStar/>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>

    </>

}

export default ProductSidebar